import tw, { styled } from 'twin.macro';

import { motion } from '@sopranodesign/framer-motion';
import { hexToRgba } from '@sopranodesign/pulse-component-hooks';

const UserIcon = styled(motion.div)`
  ${tw`font-poppins w-12 h-12 rounded-full text-xl flex font-bold items-center justify-center flex-shrink-0 uppercase`}
  color: ${({ theme, colour = 'primary' }) => theme[colour]};
  background-color: ${({ theme, background_colour = 'primary' }) => {
    return hexToRgba(theme[background_colour], 0.25);
  }};
`;

export default UserIcon;
